export default "__VITE_ASSET__6e4ac5fc__"